import { Fragment } from 'react';

import SummaryProjectsRow from './summary-projects-row';
// import SummaryCollateralRow from './summary-collateral-row';
import SummaryValidationsRow from './summary-validations-row';

import { useSummary } from 'contexts/summary.context';

const SummaryList = () => {
  const { summary } = useSummary();

  return (
    <Fragment>
      {summary.some((item) => item === 'projects') && <SummaryProjectsRow />}
      {/* {summary.some((item) => item === 'collateral') && (
        <SummaryCollateralRow />
      )} */}
      {summary.some((item) => item === 'validations') && (
        <SummaryValidationsRow />
      )}
    </Fragment>
  );
};

export default SummaryList;
